export const DISCOUNT_DETAIL_PROPOSITIONS = [
  "jusqu'au " + new Date(new Date().setMonth(new Date().getMonth() + 1)).toLocaleDateString(),
  "jusqu'au " + new Date(new Date().setMonth(new Date().getMonth() + 2)).toLocaleDateString(),
  "jusqu'au " + new Date(new Date().setMonth(new Date().getMonth() + 3)).toLocaleDateString(),
  "jusqu'au " + new Date(new Date().setMonth(new Date().getMonth() + 4)).toLocaleDateString(),
  "jusqu'au " + new Date(new Date().setMonth(new Date().getMonth() + 5)).toLocaleDateString(),
  "jusqu'au " + new Date(new Date().setMonth(new Date().getMonth() + 6)).toLocaleDateString(),
];
